const SolarSystem = () => {
    return (
      <div className="w-full h-[500px]">
        <iframe
          src="https://eyes.nasa.gov/apps/solar-system/#/home?embed=true"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
        ></iframe>
      </div>
    );
  };
  
  export default SolarSystem;
  